/**
 * The page is imported from **its own module**, not from the `@pages` barrel.
 *
 * The barrel re-exports every page, so a route importing it pulls all of them into one shared chunk
 * that the entry then preloads — code-splitting by route, defeated by one import.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@pages/documents';
import { DocumentModel } from '@units/document';
import { IamService } from '@units/iam';

/**
 * `/documents` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * **Раздел отдан реестру принятых документов, а не конструктору шаблонов.** Изначально он был
 * зарезервирован под конструктор (`template:read`), и это было верно, пока за ним стояла заглушка.
 * Теперь за ним стоит вход материала в контур: приём файла, разбор на пункты и перечень того, о чём
 * ассистент вообще может ответить. Метка раздела — «Документы» — описывает именно это; конструктор
 * шаблонов получит свой раздел вместе с собственным экраном, а до тех пор `template:read` сторожил
 * бы страницу, которой не существует, и прятал бы ту, которая есть.
 *
 * Право — `document:read`: раздел показывает документы, а не собирает их из шаблонов.
 *
 * **Схема отбора — состояние экрана**, провалидированное здесь, чтобы правленный руками адрес не
 * доехал до компонента: неизвестное состояние разбора, страница словом, порядок, которого нет, —
 * каждое падает в своё умолчание **внутри схемы**, а не заменяет экран границей ошибки. Сервер
 * поступает наоборот и отвечает 422, потому что там неизвестное значение означает, что его прислал
 * клиент.
 */
export const Route = createFileRoute('/_authenticated/documents/')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'document:read',
    // The section is in the navigation of everybody who holds the right to it, so its existence is
    // no secret inside the organization and the refusal may name what is missing. The documents
    // *inside* it are the closed contour, and answer 404 (`rules/permissions.mdc`).
    whenDenied: 'forbidden',
  }),
  validateSearch: DocumentModel.documentRegistrySearchSchema,
  component: DocumentsPage,
  staticData: { crumbKey: 'nav.documents' },
});
